import styled from 'styled-components';
import { IconWithText } from '../../../stories/molecules';
import { getSpacing, Spacing } from '../../../utils';

export const StyledButton = styled(IconWithText)<{ margin?: Spacing }>`
  background-color: ${({ theme: { palette, color } }) => (palette.mode === 'dark' ? color.white : color.primary)};
  margin: ${({ theme: { spacing }, margin }) => margin && getSpacing(margin, spacing)};
  height: ${({ theme: { spacing } }) => spacing(10)};
  & > div {
    color: ${({ theme: { palette, color } }) => (palette.mode === 'dark' ? color.primary : color.white)};
  }
`;
